import { assoc, has, unless } from 'ramda';

// ensure new filter items have status='active' set
export const setFilterItemStatusActive = unless(
  has('status'),
  assoc('status', 'active')
);
